exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.commissions td[data-v-6593608c]:nth-child(2) {\n  width: 20%;\n}\n.commissions td:nth-child(2) > input[data-v-6593608c] {\n    width: 5rem;\n}\n.glued-left-min-width[data-v-6593608c] {\n  min-width: 2.25rem;\n}\n.form-error-msg[data-v-6593608c] {\n  margin-bottom: -1.565rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6593608c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/people/agents/AgentCommissions.vue
// module id = 1237
// module chunks = 0